"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazy = void 0;
exports.lazy = (() => {
    const awaitings = {};
    const call = (id, fn, threshold = 1000) => {
        const awaiting = awaitings[id];
        if (awaiting) {
            clearTimeout(awaiting.timer);
            awaiting.timer = setTimeout(() => {
                awaiting.schedule();
            }, threshold);
        }
        else {
            Object.assign(awaiting, { fn });
            const promise = new Promise((resolve, reject) => {
                const schedule = () => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        delete awaitings[id];
                        resolve(yield awaiting.fn());
                    }
                    catch (err) {
                        reject(err);
                    }
                });
                Object.assign(awaiting, {
                    timer: setTimeout(schedule, threshold),
                    schedule,
                });
            });
            Object.assign(awaiting, { promise });
            awaitings[id] = awaiting;
        }
        return awaiting.promise;
    };
    return { call };
})();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGF6eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvdXRpbHMvbGF6eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBYSxRQUFBLElBQUksR0FBRyxDQUFDLEdBQUcsRUFBRTtJQUN4QixNQUFNLFNBQVMsR0FBRyxFQUFFLENBQUM7SUFFckIsTUFBTSxJQUFJLEdBQUcsQ0FBQyxFQUFVLEVBQUUsRUFBRSxFQUFFLFNBQVMsR0FBRyxJQUFJLEVBQUUsRUFBRTtRQUNoRCxNQUFNLFFBQVEsR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLENBQUM7UUFFL0IsSUFBSSxRQUFRLEVBQUU7WUFDWixZQUFZLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO1lBQzdCLFFBQVEsQ0FBQyxLQUFLLEdBQUcsVUFBVSxDQUFDLEdBQUcsRUFBRTtnQkFDL0IsUUFBUSxDQUFDLFFBQVEsRUFBRSxDQUFDO1lBQ3RCLENBQUMsRUFBRSxTQUFTLENBQUMsQ0FBQztTQUNmO2FBQU07WUFDTCxNQUFNLENBQUMsTUFBTSxDQUFDLFFBQVEsRUFBRSxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7WUFFaEMsTUFBTSxPQUFPLEdBQUcsSUFBSSxPQUFPLENBQUMsQ0FBQyxPQUFPLEVBQUUsTUFBTSxFQUFFLEVBQUU7Z0JBQzlDLE1BQU0sUUFBUSxHQUFHLEdBQVMsRUFBRTtvQkFDMUIsSUFBSTt3QkFDRixPQUFPLFNBQVMsQ0FBQyxFQUFFLENBQUMsQ0FBQzt3QkFDckIsT0FBTyxDQUFDLE1BQU0sUUFBUSxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7cUJBQzlCO29CQUFDLE9BQU8sR0FBRyxFQUFFO3dCQUNaLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQztxQkFDYjtnQkFDSCxDQUFDLENBQUEsQ0FBQztnQkFDRixNQUFNLENBQUMsTUFBTSxDQUFDLFFBQVEsRUFBRTtvQkFDdEIsS0FBSyxFQUFFLFVBQVUsQ0FBQyxRQUFRLEVBQUUsU0FBUyxDQUFDO29CQUN0QyxRQUFRO2lCQUNULENBQUMsQ0FBQztZQUNMLENBQUMsQ0FBQyxDQUFDO1lBRUgsTUFBTSxDQUFDLE1BQU0sQ0FBQyxRQUFRLEVBQUUsRUFBRSxPQUFPLEVBQUUsQ0FBQyxDQUFDO1lBRXJDLFNBQVMsQ0FBQyxFQUFFLENBQUMsR0FBRyxRQUFRLENBQUM7U0FDMUI7UUFFRCxPQUFPLFFBQVEsQ0FBQyxPQUFPLENBQUM7SUFDMUIsQ0FBQyxDQUFDO0lBRUYsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO0FBQ2xCLENBQUMsQ0FBQyxFQUFFLENBQUMifQ==